import React from 'react';
import styles from './style.less';

export default function GISBg() {
  return (
    <div className={styles.root} aria-hidden="true">
      <svg
        className={styles.svg}
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <radialGradient id="gis-pin-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#7fd1ff" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#7fd1ff" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="gis-soft-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#3a6ea5" stopOpacity="0.22" />
            <stop offset="100%" stopColor="#3a6ea5" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* 背景柔光 */}
        <ellipse cx="1050" cy="180" rx="460" ry="380" fill="url(#gis-soft-glow)" />
        <ellipse cx="220" cy="700" rx="420" ry="360" fill="url(#gis-soft-glow)" />

        {/* 地球经纬网格 */}
        <g opacity="0.18" fill="none" stroke="#cfe0ff" strokeWidth="1.4">
          <circle cx="1190" cy="150" r="200" />
          <ellipse cx="1190" cy="150" rx="80" ry="200" />
          <ellipse cx="1190" cy="150" rx="145" ry="200" />
          <line x1="990" y1="150" x2="1390" y2="150" />
          <line x1="1190" y1="-50" x2="1190" y2="350" />
        </g>

        {/* 等高线地形 */}
        <g opacity="0.12" fill="none" stroke="#cfe0ff" strokeWidth="1.1">
          <path d="M-40,640 C200,590 320,660 500,630 C680,600 780,670 980,630 S1300,580 1500,640" />
          <path d="M-40,700 C220,650 340,720 540,690 C740,660 820,730 1020,690 S1320,640 1500,700" />
          <path d="M-40,760 C240,720 360,780 560,750 C760,720 860,790 1060,750 S1340,700 1500,760" />
          <path d="M-40,820 C260,780 380,840 580,810 C780,780 900,850 1100,810 S1360,760 1500,820" />
        </g>

        {/* GIS 分析员工作场景（人物 + 大型地图屏幕） */}
        <g transform="translate(300, 600)" opacity="0.5">
          {/* 工作台 */}
          <rect x="-170" y="30" width="340" height="14" rx="6" fill="#cfe0ff" opacity="0.85" />
          <rect x="-150" y="44" width="10" height="76" fill="#cfe0ff" opacity="0.45" />
          <rect x="140" y="44" width="10" height="76" fill="#cfe0ff" opacity="0.45" />
          {/* 大屏幕 */}
          <rect x="-110" y="-140" width="220" height="140" rx="10" fill="none" stroke="#cfe0ff" strokeWidth="3" opacity="0.9" />
          {/* 屏幕内地图网格 */}
          <g stroke="#cfe0ff" strokeWidth="0.8" opacity="0.5">
            <line x1="-100" y1="-120" x2="-100" y2="-10" />
            <line x1="-55" y1="-120" x2="-55" y2="-10" />
            <line x1="-10" y1="-120" x2="-10" y2="-10" />
            <line x1="35" y1="-120" x2="35" y2="-10" />
            <line x1="80" y1="-120" x2="80" y2="-10" />
            <line x1="-110" y1="-95" x2="110" y2="-95" />
            <line x1="-110" y1="-60" x2="110" y2="-60" />
            <line x1="-110" y1="-25" x2="110" y2="-25" />
          </g>
          {/* 屏幕内路径与定位点 */}
          <path
            d="M-80,-100 C-50,-110 -15,-80 20,-90 C55,-100 80,-60 95,-45"
            fill="none"
            stroke="#7fd1ff"
            strokeWidth="2.2"
            strokeDasharray="1 7"
            strokeLinecap="round"
          />
          <circle cx="-80" cy="-100" r="4" fill="#7fd1ff" />
          <circle cx="95" cy="-45" r="4" fill="#7fd1ff" />
          <path
            d="M20,-90 C12,-96 12,-104 20,-108 C28,-104 28,-96 20,-90 Z"
            fill="#7fd1ff"
          />
          {/* 屏幕支架 */}
          <rect x="-6" y="0" width="12" height="30" fill="#cfe0ff" opacity="0.85" />
          {/* 人物：头 */}
          <circle cx="-185" cy="-130" r="17" fill="#cfe0ff" />
          {/* 人物：身体 */}
          <path
            d="M-212,-110 C-218,-55 -206,-10 -185,25 C-164,-10 -152,-55 -158,-110 Z"
            fill="#cfe0ff"
            opacity="0.9"
          />
          {/* 人物：伸向屏幕的手臂 */}
          <path
            d="M-165,-60 C-145,-72 -128,-84 -112,-92"
            stroke="#cfe0ff"
            strokeWidth="10"
            strokeLinecap="round"
            fill="none"
            opacity="0.9"
          />
        </g>

        {/* 地图定位点（带柔光） */}
        <g transform="translate(760, 300)" opacity="0.6">
          <circle r="60" fill="url(#gis-pin-glow)" />
          <path
            d="M0,0 C-26,-26 -26,-62 0,-76 C26,-62 26,-26 0,0 Z"
            fill="none"
            stroke="#cfe0ff"
            strokeWidth="2"
          />
          <circle cx="0" cy="-46" r="11" fill="#cfe0ff" opacity="0.7" />
          <circle cx="0" cy="-46" r="4" fill="#7fd1ff" />
        </g>
        <g transform="translate(1120, 620)" opacity="0.5">
          <circle r="48" fill="url(#gis-pin-glow)" />
          <path
            d="M0,0 C-22,-22 -22,-52 0,-64 C22,-52 22,-22 0,0 Z"
            fill="none"
            stroke="#cfe0ff"
            strokeWidth="2"
          />
          <circle cx="0" cy="-38" r="9" fill="#cfe0ff" opacity="0.7" />
          <circle cx="0" cy="-38" r="3.5" fill="#7fd1ff" />
        </g>

        {/* GIS 路径与节点 */}
        <g opacity="0.4">
          <path
            d="M760,300 C860,340 960,260 1080,320 C1150,355 1180,480 1220,540"
            fill="none"
            stroke="#7fd1ff"
            strokeWidth="2.5"
            strokeDasharray="1 9"
            strokeLinecap="round"
          />
          <circle cx="1080" cy="320" r="5" fill="#7fd1ff" />
          <circle cx="1220" cy="540" r="5" fill="#7fd1ff" />
        </g>

        {/* 坐标文字与刻度线 */}
        <g opacity="0.35">
          <text x="1150" y="790" fill="#cfe0ff" fontSize="14" fontFamily="monospace" letterSpacing="2">
            34.02°N 113.77°E
          </text>
          <line x1="1090" y1="800" x2="1210" y2="800" stroke="#cfe0ff" strokeWidth="0.8" strokeDasharray="3 3" />
        </g>

        {/* 指南针 */}
        <g transform="translate(1330, 120)" opacity="0.3">
          <circle r="34" fill="none" stroke="#cfe0ff" strokeWidth="1.2" />
          <path d="M0,-28 L7,0 L0,28 Z" fill="#cfe0ff" />
          <path d="M0,-28 L-7,0 L0,28 Z" fill="none" stroke="#cfe0ff" strokeWidth="1.2" />
          <text x="0" y="-42" textAnchor="middle" fill="#cfe0ff" fontSize="12">N</text>
        </g>

        {/* SuperMap 品牌水印 */}
        <text
          x="90"
          y="860"
          fill="#cfe0ff"
          opacity="0.18"
          fontSize="60"
          fontWeight="700"
          letterSpacing="10"
        >
          SuperMap GIS
        </text>
      </svg>
    </div>
  );
}